import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Service, { inject } from '@ember/service';
import { shouldShowSdiNotification } from '../lib/application-helpers.js';
import '../lib/utility/ajax.js';
import '@ember/object';
import { escapeHtml } from '../lib/utility/strings.js';
import '@ember/utils';
import 'moment-timezone';
import 'ember-inflector';
import '../lib/utility/province.js';

var _class, _descriptor, _descriptor2;

/**
 * Servizio NotificationMessage
 * Gestisce i messaggi di notifica (abbonamento, sms, SDI, errori, warning)
 * mostrati all'utente tramite il servizio notify.
 * Estratto dal god-controller application (maintainability 4.2), comportamento invariato.
 */
let NotificationMessageService = (_class = class NotificationMessageService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "notify", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
  }
  showNotificationMessage(me) {
    this.showSubscriptionNotification(me);
    this.showSmsNotification(me);
    this.showSdiNotification(me);
  }
  showSubscriptionNotification(me) {
    const giorni_rimanenti = me.organization?.subscription?.giorni_rimanenti;
    if (giorni_rimanenti <= 0) {
      // giorni_rimanenti is 0 or negative once expired; the message reads
      // "expired N days ago", so it takes the days elapsed since expiry.
      this.showErrorMessage(this.intl.t('your subscription is expired # day ago', {
        day: Math.abs(giorni_rimanenti)
      }));
    } else if (giorni_rimanenti <= 5) {
      this.showWarningMessage(this.intl.t('your subscription expire in # day', {
        day: giorni_rimanenti
      }));
    }
  }
  showSmsNotification(me) {
    const sms_rimanenti = me.organization?.subscription?.sms_rimanenti;
    if (sms_rimanenti || sms_rimanenti === 0) {
      let htmlMessage = '';
      if (sms_rimanenti <= 0) {
        htmlMessage = `<p>${this.intl.t('sms out of stock')}</p>`;
      } else {
        htmlMessage = `<p>${this.intl.t('you have only # sms left', {
          sms: sms_rimanenti
        })}</p>`;
      }
      htmlMessage += `<a href="/${me.role?.redirect_page || 'start'}/settings/plan?tab=usage" class='button expanded'>${this.intl.t('msg buy package')}</a>`;

      // single threshold: any remainder <= 50 warns (message text above
      // already distinguishes the out-of-stock case)
      if (sms_rimanenti <= 50) {
        this.showErrorMessage(htmlMessage);
      }
    }
  }
  showSdiNotification(me) {
    const sdi_rimanenti = me.organization?.subscription?.sdi_rimanenti_json;
    if (sdi_rimanenti && Array.isArray(sdi_rimanenti)) {
      for (let i = 0; i < sdi_rimanenti.length; i++) {
        const sdi = sdi_rimanenti[i];
        if (this.shouldShowSdiNotification(me, sdi)) {
          let htmlMessage = '';
          // sdi.contatto is a user-entered contact name: escape it before
          // injecting into notification HTML (stored XSS).
          const contatto = escapeHtml(sdi.contatto);
          if (sdi.perc_rimanente <= 0) {
            htmlMessage = `<p>${contatto} ${this.intl.t('e-invoices out of stock')}</p>`;
          } else {
            htmlMessage = `<p>${contatto} ${this.intl.t('you have only # inv', {
              inv: sdi.num
            })}</p>`;
          }
          htmlMessage += `<a href="/${me.role?.redirect_page || 'start'}/settings/plan?tab=usage" class='button expanded'>${this.intl.t('msg buy package')}</a>`;
          if (sdi.perc_rimanente <= 0) {
            this.showErrorMessage(htmlMessage);
          } else if (sdi.perc_rimanente <= 5) {
            this.showErrorMessage(htmlMessage);
          } else if (sdi.perc_rimanente <= 10) {
            this.showWarningMessage(htmlMessage);
          }
        }
      }
    }
  }
  shouldShowSdiNotification(me, sdi) {
    return shouldShowSdiNotification(me, sdi);
  }
  showErrorMessage(message) {
    this.notify.error({
      html: message,
      closeAfter: null
    });
  }
  showWarningMessage(message) {
    this.notify.warning({
      html: message,
      closeAfter: null
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "notify", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { NotificationMessageService as default };
//# sourceMappingURL=notification-message.js.map
